import * as constants from './constants';
import { router } from './router';

export const JednotnaFrontaNd = {
	name: constants.NAME,
	constants,
	router,
};
